import { MdDelete } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { University_Table_Model } from "../../Models/universityModel";
import { useDispatch } from "react-redux";
import { UNIVERSITY_SINGLE_DATA } from "../../Actions/universityAction";

export default function UniversityTableRow({
  University_Id,
  University_Name,
  Country,
  World_Ranking, //int
  Country_Ranking, //int
  University_Address,
  Affiliation, // dropdown int 0 or 1
  Affiliation_Pathway,
  Contact_Person,
  Contact_Number, // type mobile number
  Contact_Email,
  Commision_Percentage_PG, // float
  Commision_Including_GST, //drop down 1 0  yes/no
  Commission_Duration,
  Lumpsum_Commision,
  Attachment_Name,
  Commision_Percentage_UG, // float
  Commision_Percentage_Other, // float
  Partnership,
  handleEditUniversityData,
  handleDeleteUniversity,
}) {
  const dispatch = useDispatch();
  const data = [
    "delete",
    University_Name,
    University_Address,
    Country,
    Contact_Person,
    Contact_Email,
    World_Ranking, //int
    Country_Ranking, //int
    Affiliation, // dropdown int 0 or 1
    Affiliation_Pathway,
    Contact_Number,
    Attachment_Name, // type mobile number
    Partnership,
    Commision_Percentage_PG, // float
    Commision_Including_GST, //drop down 1 0  yes/no
    Commission_Duration,
    Lumpsum_Commision,
    Attachment_Name,
    Commision_Percentage_UG, // float
    Commision_Percentage_Other, // float
  ];

  const handleEdit = (e) => {
    e.preventDefault();
    handleEditUniversityData(University_Id);
    dispatch(UNIVERSITY_SINGLE_DATA(University_Id));
  };

  // Handle Delete Table function
  const handleDelete = (e) => {
    e.preventDefault();
    handleDeleteUniversity(University_Id);
  };

  return (
    <tr>
      {University_Table_Model?.map((el, i) => (
        <td key={i + Math.random()}>
          {data[i] === "delete" ? (
            <span className={data[i] === "delete" ? "Edit_Delete" : ""}>
              <span onClick={(e) => handleEdit(e)}>
                <TbEdit />
              </span>
              <span onClick={handleDelete}>
                <MdDelete />
              </span>
            </span>
          ) : (
            data[i]
          )}
        </td>
      ))}
    </tr>
  );
}
